var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isFunction, isString } from '../_internal/data';
import { ANIMATION_DURATIONS } from '../animations';
import { RoundIconButton } from '../RoundIconButton';
import { Title } from '../Title';
import { useCurrentBackground } from '../useCurrentBackground';
import { withFloatingPanelBehavior, } from '../withFloatingPanelBehavior';
import { withTriggerElement } from '../withTriggerElement';
import { ModalOverlay, ModalContainer, ModalContent, ModalScrollableContent, HeaderBarContainer, } from './Modal.style';
var InnerModal = React.forwardRef(function (props, ref) {
    var _a;
    var modal = props.modal, parentFloatingPanelRef = props.parentFloatingPanelRef, children = props.children, title = props.title, _b = props.width, width = _b === void 0 ? 'regular' : _b, rest = __rest(props, ["modal", "parentFloatingPanelRef", "children", "title", "width"]);
    var backgroundColor = useCurrentBackground({ useRootTheme: true });
    if (!modal.hasAlreadyBeenOpened) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(ModalOverlay, { "data-state": modal.state, "data-testid": "modal-overlay", style: {
            '--modal-animation-duration': "".concat(modal.animationDuration, "ms"),
        } },
        React.createElement(ModalContainer, __assign({ backgroundColor: backgroundColor, ref: ref, "data-testid": "modal-container", "data-width": width }, rest),
            React.createElement(HeaderBarContainer, null,
                isString(title) ? (React.createElement(Title, { type: "section" }, title)) : (title !== null && title !== void 0 ? title : React.createElement("div", null)),
                React.createElement(RoundIconButton, { onClick: modal.close, icon: "close" })),
            React.createElement(ModalContent, null,
                React.createElement(ModalScrollableContent, null, isFunction(children) ? children(modal) : children)))), (_a = parentFloatingPanelRef === null || parentFloatingPanelRef === void 0 ? void 0 : parentFloatingPanelRef.current) !== null && _a !== void 0 ? _a : document.body);
});
export var Modal = withTriggerElement()(withFloatingPanelBehavior({
    animated: true,
    persistent: false,
    animationDuration: ANIMATION_DURATIONS.m,
})(InnerModal));
//# sourceMappingURL=Modal.js.map